import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { finalize, Subject } from 'rxjs';

export interface HotKeysOptions {
    element?: HTMLElement;
    target?: 'document';
    keys: string;
    onKey?: 'keyup' | 'keydown';
}

@Injectable()
export class HotKeysService {
    defaults: Partial<HotKeysOptions> = {
        target: 'document',
        onKey: 'keydown',
    };
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private eventManager: EventManager
    ) {}

    addShortcut$(options: HotKeysOptions) {
        const mergedOptions = { ...this.defaults, ...options };
        // https://github.com/angular/angular/blob/master/packages/platform-browser/src/dom/events/key_events.ts
        const event = `${mergedOptions.onKey}.${mergedOptions.keys}`;
        const _eventSubscription: Subject<Event> = new Subject();

        let removeEventListener: Function;
        if (mergedOptions.element) {
            removeEventListener = this.eventManager.addEventListener(
                mergedOptions.element as HTMLElement,
                event,
                (handlerEvent: Event) => {
                    handlerEvent.preventDefault();
                    _eventSubscription.next(handlerEvent);
                }
            );
        } else {
            removeEventListener = this.eventManager.addEventListener(
                this.document.documentElement,
                event,
                (handlerEvent: Event) => {
                    handlerEvent.preventDefault();
                    _eventSubscription.next(handlerEvent);
                }
            );
        }

        return _eventSubscription.pipe(
            finalize(() => {
                removeEventListener();
            })
        );
    }
}
